import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { PaginationInstance } from 'ngx-pagination';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserState, getFiledId } from 'src/app/shared/state/user/user.reducer';
import { ToastNotificationService } from 'src/app/shared/toast-notification/toast-notification.service';
import { BigCommerceService } from '../big-commerce.service';
import { BcModalComponent } from '../bc-modal/bc-modal.component';
import { ViewProductComponent } from '../view-product/view-product.component';

@Component({
	selector: 'app-product-card',
	templateUrl: './product-card.component.html',
	styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit {
	@Input() products = [];
	@Output() public pageNumber: EventEmitter<number> = new EventEmitter();
	@Output() public selectedItem: EventEmitter<object> = new EventEmitter();
	@Output() public bulkPayload: EventEmitter<any[]> = new EventEmitter();
	@Output() public sortType: EventEmitter<string> = new EventEmitter();
	@ViewChild('p') pagination;
	public config: PaginationInstance = {
		id: '1',
		itemsPerPage: 30,
		currentPage: 1,
		totalItems: 0
	};
	radioForm: FormGroup;
	checked: boolean;
	selectionText = 'Select All';
	selectedItemIndex: number;
	productId: number;
	Math = Math;
	private unsubscriber$ = new Subject<void>();
	newlyGenerated: boolean;
	count: number;
	selectedProducts: any[];
	history: boolean;
	scrWidth: number;
	unSelectedProducts = [];
	filedId: number;

	constructor(
		private router: Router,
		private dialog: MatDialog,
		private activatedRoute: ActivatedRoute,
		private userStore: Store<UserState>,
		private bigCommerceService: BigCommerceService,
		private toastNotificationService: ToastNotificationService
	) {
		this.userStore.pipe(select(getFiledId), takeUntil(this.unsubscriber$)).subscribe(id => {
			this.filedId = id;
		});
	}

	@HostListener('window:resize', ['$event'])
	getScreenSize(event?): void {
		this.scrWidth = window.innerWidth;
	}

	ngOnInit(): void {
		this.scrWidth = window.innerWidth;
		this.radioForm = new FormGroup({});
		for (let i = 0; i < this.products?.length; i++) {
			this.radioForm.addControl('radio' + i, new FormControl(false));
		}
		let selectedProduct = this.products.find((item, index) => {
			if (item.id == this.productId) {
				this.selectedItemIndex = index;
				return item;
			}
		});
		this.radioForm.valueChanges.subscribe(val => {
			this.count = 0;
			this.selectedProducts = [];
			for (let [key, value] of Object.entries(val)) {
				if (value) {
					this.count++;
					this.selectedProducts.push(key);
				} else {
					this.unSelectedProducts.push(key);
				}
			}
			let flag = true;
			for (let [key, value] of Object.entries(val)) {
				if (value) {
					flag = true;
				} else {
					flag = false;
					break;
				}
			}
			flag ? (this.selectionText = 'Deselect All') : (this.selectionText = 'Select All');
		});
		this.selectedItem.emit(selectedProduct);
		this.getActivatedRoute();
	}

	public getActivatedRoute(): void {
		this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscriber$)).subscribe(params => {
			if (params['type'] == 'newly-generated') {
				this.newlyGenerated = true;
			}
			if (params['type'] == 'history') {
				this.history = true;
			}
		});
	}

	openEditor(id: number): void {
		this.router.navigate(['big-commerce/generate'], { queryParams: { productId: id } });
	}

	sortProducts(type: string): void {
		this.sortType.emit(type);
	}

	editDescription(item: any): void {
		console.log(item);
		this.router.navigate(['big-commerce/generate'], { queryParams: { productId: item.productId, edit: true } });
		// this.isEditable = !this.isEditable;
		// this.editId = item.productId;
		// if (!this.isEditable) {
		// 	item.generatedData.description = document.getElementById(item.productId).innerText;
		// 	this.updateDescription(item);
		// }
	}

	confirmBulkSave(): void {
		let modalConfig;
		let isMobile = this.scrWidth < 780 ? true : false;
		if (isMobile) {
			modalConfig = {
				width: '90%',
				height: '328px',
				maxWidth: '100%',
				hasBackdrop: false
			};
		} else {
			modalConfig = {
				width: '436px',
				height: '328px',
				hasBackdrop: true
			};
		}
		const dialogRef = this.dialog.open(BcModalComponent, {
			...modalConfig,
			panelClass: 'modal-wrapper',
			disableClose: true,
			data: {
				title: 'Please Confirm',
				desc: 'This process will update your current Big Commerce product description immediately.',
				isCancel: true,
				cta: 'Update'
			}
		});
		dialogRef.afterClosed().subscribe(res => {
			if (res.confirm) {
				this.saveAll();
			}
		});
	}

	saveAll(): void {
		let ids = [];
		this.unSelectedProducts.forEach(item => {
			let index = item.slice(-1);
			ids.push(this.products[index].productId);
		});
		const payload = {
			user: {
				user_filed_id: this.filedId
			},
			data: {
				product_ids: ids
			}
		};
		this.bigCommerceService
			.saveBulk(payload)
			.pipe(takeUntil(this.unsubscriber$))
			.subscribe(
				response => {
					this.toastNotificationService.sendSuccessToast('Process started...');
					this.router.navigate(['big-commerce']);
				},
				() => {},
				() => {}
			);
	}

	public previewProduct(item: object): void {
		let isMobile = false;
		if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Tablet/i)) {
			isMobile = true;
		}
		let modalConfig;
		if (isMobile) {
			modalConfig = {
				width: '93%',
				height: '85%',
				maxWidth: '100%',
				hasBackdrop: true
			};
		} else {
			modalConfig = {
				width: '1053px',
				height: '763px',
				hasBackdrop: true
			};
		}
		const dialogRef = this.dialog.open(ViewProductComponent, {
			...modalConfig,
			disableClose: true,
			data: {
				existing: true
			}
		});
		dialogRef.backdropClick().subscribe(() => {
			dialogRef.close();
		});
		dialogRef.componentInstance.modelDetail = {
			product: item
		};
		dialogRef.afterClosed().subscribe(obj => {
			// console.log(obj);
		});
	}

	checkAll(): void {
		if (this.selectionText == 'Select All') {
			this.selectionText = 'Deselect All';
			Object.keys(this.radioForm.controls).forEach(key => {
				this.radioForm.controls[key].setValue(true);
			});
		} else {
			this.selectionText = 'Select All';
			Object.keys(this.radioForm.controls).forEach(key => {
				this.radioForm.controls[key].setValue(false);
			});
		}
	}

	public setPage(page: number): void {
		this.config.id = page.toString();
		this.pageNumber.emit(page);
	}

	generateDescription(): void {
		let payloadData = [];
		this.selectedProducts.forEach(item => {
			let index = item.slice(-1);
			payloadData.push(this.products[index]);
		});
		if (this.newlyGenerated) {
			payloadData = payloadData.map(item => {
				return { product_id: item.productId, title: item.generatedData.title, description: item.generatedData.description, images: item.images };
			});
		} else {
			payloadData = payloadData.map(item => {
				return { product_id: item.id, title: item.title, description: item.description, images: item.images };
			});
		}
		this.bulkPayload.emit(payloadData);
	}

	clearSelected(): void {
		this.count = 0;
		this.selectedProducts = [];
		this.radioForm.reset();
	}
}
